import { SetStateAction } from 'react';

import { SelectedG500LiteMasterInfoType } from '../../../common/component/hooks/useStateSelectedG500LiteMasterInfo';
import { SelectedOffsegMasterInfoType } from '../../../common/component/hooks/useStateSelectedOffsegMasterInfo';
import { DateType, formatDate } from '../../../common/utils/dateHandler';
import { DialogType } from '../../../common/type/DialogType';

import { getEventVideoHandler } from '../../feature/handler/getEventVideoHandler';
import { EventVideoInfoType } from '../../feature/type/EventVideoInfoType';

type InputType = {
	setIsAsyncProcess: (value: SetStateAction<boolean>) => void;
	selectedOffsegMasterInfo: SelectedOffsegMasterInfoType;
	selectedG500LiteMasterInfo: SelectedG500LiteMasterInfoType;
	startDate: DateType | null;
	endDate: DateType | null;
	setDialog: (value: SetStateAction<DialogType>) => void;
	setEventVideoInfoList: (value: React.SetStateAction<EventVideoInfoType[]>) => void;
};

/**
 * イベント映像一覧取得用カスタムフック
 */
export const useGetEventVideo = (input: InputType) => {
	const { setIsAsyncProcess, selectedOffsegMasterInfo, selectedG500LiteMasterInfo, startDate, endDate, setDialog, setEventVideoInfoList } = input;

	// 検索ボタンを押下した際の処理
	const onClickSearch = async () => {
		setIsAsyncProcess(true);

		const requestParams = {
			offsegOrganizationId: selectedOffsegMasterInfo.selectedOffsegOrganizationInfo.id,
			offsegDriverId: selectedOffsegMasterInfo.selectedOffsegDriverInfo.id,
			g500LiteOrganizationId: selectedG500LiteMasterInfo.selectedG500LiteOrganizationInfo.id,
			g500LiteDriverId: selectedG500LiteMasterInfo.selectedG500LiteDriverInfo.id,
			startDate: formatDate(startDate),
			endDate: formatDate(endDate),
		};

		// イベント映像一覧を取得
		const [dialog, eventVideoInfoList] = await getEventVideoHandler(requestParams);

		setIsAsyncProcess(false);

		if (!eventVideoInfoList) {
			setDialog(dialog);
			return;
		}

		setEventVideoInfoList(eventVideoInfoList);
	};

	return { onClickSearch };
};
